import React from 'react';
import { Star, Check } from 'lucide-react';
import { motion } from 'framer-motion';
import { PressLogos } from './graphics/Graphics';
export function Hero() {
  return <section className="bg-cream pt-[100px] pb-12 md:pt-[136px] md:pb-20 px-5 overflow-hidden" data-id="element-359">
      <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-360">
        {/* Mobile Image (shows first on mobile) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full md:hidden rounded-xl overflow-hidden shadow-subtle" data-id="element-361">
          <img src="https://cdn.magicpatterns.com/uploads/8rPah4XQBwyaMahWvTWqAB/ChatGPT_Image_May_8,_2026,_04_14_10_PM.png" alt="Woman holding DryControl with bladder support benefits" className="w-full h-auto object-cover aspect-[5/4]" data-id="element-362" />
        </motion.div>

        {/* Left Column */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full md:w-[48%]" data-id="element-363">
          <div className="text-[12px] font-inter uppercase tracking-[0.1em] text-secondary mb-4" data-id="element-364">
            Women's Health & Wellbeing | UK Edition
          </div>

          <h1 className="font-playfair text-[32px] md:text-[48px] text-ink leading-[1.2] font-semibold" data-id="element-365">
            The NHS Told 1 in 3 British Women That Leaking Was Normal. It Isn't.
            And There's Finally Something That Addresses Why It's Happening.
          </h1>

          <p className="font-inter text-[18px] text-secondary mt-5 leading-relaxed" data-id="element-366">
            DryControl™ patches work at the nerve-muscle communication layer —
            the part of the problem that pads, Kegels, and GP advice have never
            reached.
          </p>

          <div className="bg-forest text-white font-inter text-[13px] p-3 px-5 rounded-lg mt-6 shadow-subtle" data-id="element-367">
            <div className="flex flex-wrap gap-x-4 gap-y-2 justify-center md:justify-start" data-id="element-368">
              <span className="flex items-center" data-id="element-369">
                <Check className="w-3.5 h-3.5 mr-1.5 text-gold" data-id="element-370" /> No pads
              </span>
              <span className="flex items-center" data-id="element-371">
                <Check className="w-3.5 h-3.5 mr-1.5 text-gold" data-id="element-372" /> No
                prescription
              </span>
              <span className="flex items-center" data-id="element-373">
                <Check className="w-3.5 h-3.5 mr-1.5 text-gold" data-id="element-374" /> No surgery
              </span>
              <span className="flex items-center" data-id="element-375">
                <Check className="w-3.5 h-3.5 mr-1.5 text-gold" data-id="element-376" /> 7 days to
                notice the difference
              </span>
              <span className="flex items-center" data-id="element-377">
                <Check className="w-3.5 h-3.5 mr-1.5 text-gold" data-id="element-378" /> 90-day
                money-back guarantee
              </span>
            </div>
          </div>

          <button onClick={() => document.getElementById('bundles')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full md:w-auto md:min-w-[280px] bg-forest text-white font-inter font-semibold text-[16px] h-[52px] rounded-lg mt-6 hover:bg-forest/90 transition-colors shadow-subtle" data-id="element-379">
            Order Now
          </button>

          <div className="font-inter text-[13px] text-secondary mt-3 text-center md:text-left" data-id="element-380">
            Free UK delivery · Discreet packaging · Ships within 24 hours
          </div>

          <div className="flex items-center justify-center md:justify-start mt-4 space-x-2" data-id="element-381">
            <div className="flex" data-id="element-382">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-gold fill-gold" data-id="element-383" />)}
            </div>
            <span className="font-inter text-[13px] text-secondary" data-id="element-384">
              4.8 out of 5 — 11,200+ verified reviews
            </span>
          </div>
        </motion.div>

        {/* Right Column (Desktop Image) */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="hidden md:block w-[52%]" data-id="element-385">
          <div className="rounded-xl overflow-hidden shadow-subtle" data-id="element-386">
            <img src="https://cdn.magicpatterns.com/uploads/8rPah4XQBwyaMahWvTWqAB/ChatGPT_Image_May_8,_2026,_04_14_10_PM.png" alt="Woman holding DryControl with bladder support benefits" className="w-full h-auto object-cover aspect-[5/4]" data-id="element-387" />
          </div>

          <div className="mt-8 pt-6 border-t border-divider flex flex-col items-center" data-id="element-388">
            <span className="font-inter text-[11px] uppercase tracking-[0.2em] text-secondary mb-4" data-id="element-389">
              As featured in
            </span>
            <PressLogos data-id="element-390" />
          </div>
        </motion.div>
      </div>
    </section>;
}